import {
    INVALIDATE_ENDPOINT,
    RECEIVE_ENDPOINT,
    REQUEST_ENDPOINT,
    REST_API,
    ADD_KEY_VALUE
} from './constants'
import { fetchEndpoint } from './fetch'
import { setMax } from './loader'

export function invalidateEndpoint(id) {
    return {
        type: INVALIDATE_ENDPOINT,
        id
    }
}

export function receiveEndpoint(id, json) {
    return {
        type: RECEIVE_ENDPOINT,
        id,
        list: json,
        receivedAt: Date.now()
    }
}

export function requestEndpoint(id) {
    return {
        type: REQUEST_ENDPOINT,
        id
    }
}



export function executeEndpointList(endpoint, token, data, httpVerb){
    return dispatch => {
        return fetch(`${REST_API}/${endpoint}/enqueue?access_token=${token}`,{
            method: httpVerb,
            headers:{
                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin' : '*'
            },
            body: JSON.stringify(data)
        }).then(response=>{
            return response.json()
        }).
        then(json => {
            return {
                success: json.success,
                message: json.message
            }
        })
    }
}

export function archiveEndpointList(endpoint,token,data,httpVerb){
    return dispatch => {
        return fetch(`${REST_API}/${endpoint}/archive?access_token=${token}`,{
            method: httpVerb,
            headers:{
                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin' : '*'
                
            },
            body: JSON.stringify(data)
        }).then(response=>{
            return response.json()
        })
        .then(json => {
            // return {
            //     success: json.success,
            //     message: json.message
            // }
            return json
        })
    }
}
// export function archiveList(endpoint,token,data,httpVerb){
//     return dispatch => {
//         return fetch(`${REST_API}/${endpoint}/archive-list?access_token=${token}`,{
//             method: httpVerb,
//             headers:{
//                 'Content-Type' : 'application/json',
//                 'Access-Control-Allow-Origin' : '*'
                
//             },
//             body: JSON.stringify(data)
//         }).then(response=>{
//             return response.json()
//         })
//         .then(json => {
//             let data = JSON.parse(json.data)
//             dispatch(setMax(data.length))
//             return json
//         })
//     }
// }

/**
 * 
 * @param {number} id - integer id of endpoint
 * @param {string} endpoint - name of endpoint
 * @param {string} token - auth token
 * @param {Object} data - json data to be saved
 * @param {string} httpVerb - verb to use, can either be PUT or PATCH, defaults to PUT
 */
export function editEndpointList(id, endpoint, token, data, httpVerb = 'PUT') {
    // console.log("id",id)
    // console.log("endpoint",endpoint)
    // console.log("token",token)
    // console.log("data",data)
    // console.log("JSON.stringify",JSON.stringify(data))

    
    return dispatch => {
        return fetch(`${REST_API}/${endpoint}?access_token=${token}`, {
            method: httpVerb,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'omit',
            body: JSON.stringify(data)
        }).then(response => {
            let json = response.json()
            if (response.ok) {
                dispatch(invalidateEndpoint(id))
                dispatch(fetchEndpoint(id, endpoint, token))
                //console.dir(json);
            } else {
                json.then(json => {
                    if (json.error && json.error.message) {
                        alert(json.error.message)
                    } else {
                        alert(response.status + ": " + response.statusText)
                    }
                })
            }

            return {
                response: response,
                json: json
            }
        })
    }
}

export function patchEndpointList(id, endpoint, token, data) {
    return dispatch => {
        return fetch(`${REST_API}/${endpoint}?access_token=${token}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'omit',
            body: JSON.stringify(data)
        }).then(response => {
            if (response.ok) {
                dispatch(invalidateEndpoint(id))
                dispatch(fetchEndpoint(id, endpoint, token))
            } else {
                alert(response.status + ": " + response.statusText)
            }

            return {
                response: response,
                json: response.json()
            }
        })
    }
}

export function patchEndpointRecord(id, endpoint, token, data) {

    return dispatch => {
        return fetch(`${REST_API}/${endpoint}/${id}?access_token=${token}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'omit',
            body: JSON.stringify(data)
        }).then(response => {
            
            document.location.reload()
        })
    }
}

export function addKeyValue(id, listId, listProp) {
    return {
        type: ADD_KEY_VALUE,
        id,
        listId,
        listProp
    }
}

export function deleteEndpointList(id, endpoint, listid, token) {

    return dispatch => {
        return fetch(`${REST_API}/${endpoint}/${listid}?access_token=${token}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'omit'
        }).then(response => {
            if (response.ok) {
               
                if (document.location.pathname.indexOf("/users") != -1) {

                   document.location = "/users"
                } else {

                    dispatch(fetchEndpoint(id, endpoint, token))
                }
            }

            return {
                response: response,
                json: response.json()
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/endpoints.js